

// $Classes/Enums/Interfaces(filter)[template][separator]
// filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
// template: The template to repeat for each matched item
// separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]

// More info: http://frhagn.github.io/Typewriter/


export class PSF_ProtectiveFunctionComments {
    
    public pF_CommentsID: number = 0;
    public protectiveFunction_FK: number = null;
    public processHazard: string = null;
    public sourceDescription: string = null;
    public referDocuments: string = null;
    public sourceKey: string = null;
    public sourceComments: string = null;
    public resetFunction: string = null;
    public shutdownDescription: string = null;
    public htmlDiv: string = null;
    public sourceDiagnostics: string = null;
    public createdby: number = null;
    public createdDate: Date = null;
    public updatedby: number = null;
    public updatedDate: Date = null;
    public isDeleted: boolean = null;
    public input1Config: string = null;
    public input2Config: string = null;
    public input3Config: string = null;
    public input4Config: string = null;
    public input5Config: string = null;
    public action1Config: string = null;
    public action2Config: string = null;
    public action3Config: string = null;
    public action4Config: string = null;
    public action5Config: string = null;
    public input1CCF: number = null;
    public input2CCF: number = null;
    public input3CCF: number = null;
    public input4CCF: number = null;
    public input5CCF: number = null;
    public action1CCF: number = null;
    public action2CCF: number = null;
    public action3CCF: number = null;
    public action4CCF: number = null;
    public action5CCF: number = null;
    public importProcess: string = null;
    public import: string = null;
}

